import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

export enum MonteCarloPosRange {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export type Gender = 'Unisex' | 'Male' | 'Female';

export interface ChartDataDTO {
  CalendarYear: number;
  MonteCarloProbabilityOfSuccess: number;
  PrincipalAge: number | null;
  PrincipalGender: Gender;
  PrincipalWorkingStatus: string | null;
  ProbBothBeingAlive: number | null;
  ProbPrincipalBeingAlive: number;
  ProbAtleastOneAlive: number;
  SpouseAge?: number;
  SpouseGender: Gender;
  SpouseWorkingStatus: string;
  MonteCarloPosRange: MonteCarloPosRange;
}

export interface LongevityDTO {
  PrincipalName: string;
  PrincipalRetirementYear: number;
  SpouseRetirementYear: number;
  SpouseName: string | null;
  ChartData: ChartDataDTO[];
  PrincipalGender: Gender;
  SpouseGender?: Gender;
  MonteCarloHighRange: string;
  MonteCarloMediumRange: string;
  MonteCarloLowRange: string;
  PrincipalLifeExpectancyYear: number;
  SpouseLifeExpectancyYear: number;
}

const fetchLongevityAnalysis = async (
  clientId: number,
  fpId: string | null,
): Promise<LongevityDTO> => {
  return authFetch(
    urlWithParams('/Consumer/LongevityAnalysis/GetLongevityAnalysisDetails', {
      clientId,
      fpId,
    }),
  );
};

export interface Params {
  clientId: number;
  fpId: string;
  enabled: boolean;
}

export const useLongevityAnalysisQuery = ({ clientId, fpId, enabled }: Params) => {
  return useQuery(
    queryKeys.longevity(clientId, fpId),

    () => fetchLongevityAnalysis(clientId, fpId),
    
    { enabled },
  );
};
